import { createSelector } from '@ngrx/store';
import { appFeatureSelector, AppState } from '../app.reducer';

export const selectLoading = createSelector(
  appFeatureSelector,
  (state: AppState) =>
    state.loading.routes ||
    state.lang.loading
);
